import { get } from 'lodash';

export interface OptionItemModel {
  id: number;
  name: string;
}

export function toOptionItemModel<T>(model: T, idPath: string, namePath: string): OptionItemModel {
  return {
    id: get(model, idPath),
    name: get(model, namePath),
  };
}
